export default __webpack_public_path__ + "static/media/github.8b4b2cb3.png";